const Membership = () => {
  return (
    <section className="membership" id="membership">
      <div className="container">
        <h2 className="section-title">会員募集</h2>
        <p style={{ textAlign: 'center', marginBottom: '3rem', fontSize: '1.1rem' }}>
          未来を作る仲間へ。誠実なITビジネス・プロフェッショナルが正しく評価される仕組みを共に築きましょう。
        </p>
        <div className="service-grid">
          <div className="service-card">
            <div className="service-icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h3>正会員</h3>
            <p>
              ITプロフェッショナルとして活動する個人が対象です。年会費制で、一年ごとに更新いただきます。
            </p>
            <ul style={{ textAlign: 'left', marginTop: '1rem', paddingLeft: '1.5rem' }}>
              <li>ビジネスインフラの使用</li>
              <li>ラーニング環境の使用</li>
              <li>リソースネットワークへのアクセス</li>
              <li>認定制度による信用付与</li>
            </ul>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="3" y1="9" x2="21" y2="9"></line>
                <line x1="9" y1="21" x2="9" y2="9"></line>
              </svg>
            </div>
            <h3>賛助会員</h3>
            <p>
              協会の活動に賛同いただける法人・個人の方を募集しています。協賛により、ITプロフェッショナルの活躍を支援してください。
            </p>
            <ul style={{ textAlign: 'left', marginTop: '1rem', paddingLeft: '1.5rem' }}>
              <li>協会活動への参画</li>
              <li>ネットワークへのアクセス</li>
              <li>優先的な情報提供</li>
            </ul>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3>対象となる方</h3>
            <p style={{ marginBottom: '1rem' }}>
              以下の分野で活動する方を順次募集予定です。（詳細は要相談）
            </p>
            <ul style={{ textAlign: 'left', paddingLeft: '1.5rem' }}>
              <li>ソフトウェア・エンジニア</li>
              <li>システム・エンジニア</li>
              <li>ITコンサルタント</li>
              <li>ITソリューション営業</li>
              <li>DX/AX業務改革コンサル</li>
              <li>ITマーケティング</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Membership

